<template>
  <b-container fluid>
    <b-row>
      <b-col md="12" class="table-responsive">
        <iq-card>
          <!-- Header Section -->
          <template v-slot:headerTitle>
            <div class="row align-items-center py-4 gap-response" style="display: flex; align-items: center; justify-content: flex-start; gap: 0.1rem;">
              <div class="col-auto">
                <span style="font-size: 25px; color: black;">{{mode === 'add' ? 'เพิ่มใบเสนอสินค้า' : mode ==='edit' ? 'ใบเสนอขายสินค้า/บริการ (Edit)' : 'ใบเสนอขายสินค้า/บริการ (View)'}}</span>
              </div>
              <div class="col-auto" style="display: flex; align-items: center; gap: 1rem;">
                <div v-if="mode === 'add' || mode === 'edit'">
                  <b-button v-if="mode === 'add'" type="button" variant="primary" @click="saveQuotation" class="btn-add btn-min-size" style="text-align: center;"><i class="save-data_ct"/>บันทึก</b-button>
                  <b-button v-else-if="mode === 'edit'" type="button" variant="primary" @click="editQuotation" class="btn-add btn-min-size" style="text-align: center;"><i class="save-data_ct"/>{{ QuoDetail.so_no ? 'บันทึก SO' : 'บันทึก' }}</b-button>
                </div>
                <div>
                  <b-button type="button" variant="danger" @click="handleClickBack" class="btn-min-size btn-cancel-border" style="text-align: center;">ยกเลิก</b-button>
                </div>
                <!-- SO Number Display next to cancel button -->
                <div v-if="QuoDetail.so_no" style="display: flex; align-items: center;">
                  <span style="font-size: 25px; color: black;">
                    {{QuoDetail.so_no}}{{QuoDetail.so_version ? '(' + QuoDetail.so_version + ')' : ''}}
                  </span>
                </div>
              </div>
              <!-- <div v-else class="row button-response-header" style="display: flex; align-items: center;">
                <div class="flex-response-header my-2 mx-2" style="white-space: nowrap;">
                  <div class="response-1button-header">
                    <b-button type="button" variant="danger" @click="handleClickBack" class="my-1 mx-1 w-100 btn-min-size btn-cancel-border">ยกเลิก</b-button>
                  </div>
                </div>
              </div> -->
            </div>
          </template>
          <!-- Body Section -->
          <template v-slot:body>
            <div class="mx-3">
              <b-row>
                <b-col lg="3" md="4" sm="12">
                  <b-form-group label="หมายเลขใบเสนอราคา" label-for="quo_no">
                    <template v-if="QuoDetail.quo_no === null" v-slot:label>
                      หมายเลขใบเสนอราคา<!-- <span style="color: red;"> *</span> -->
                    </template>
                    <b-form-input v-if="mode === 'add'" placeholder="Gen Quotation No." id="quo_no" :disabled="true"></b-form-input>
                    <b-form-input v-else id="quo_no" v-model="QuoDetail.quo_no" :readonly="true"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="4" sm="6">
                  <b-form-group label-for="datepicker-custom1" label="วันที่เสนอราคา">
                    <template v-if="true" v-slot:label><!-- QuoDetail.quo_date === null || QuoDetail.quo_date?.toString().trim() === '' -->
                      วันที่เสนอราคา<span style="color: red;"> *</span>
                    </template>
                    <div style="position: relative;">
                      <date-picker id="datepicker-custom1" :config="options" v-model="QuoDetail.quo_date" :readonly="mode !== 'add'"/>
                      <i class="ri-calendar-line m-0 icon-calendar-edit" @click="onClickDatePicker(1)"
                        :disabled="isDisable" style="cursor: pointer;" />
                    </div>
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="4" sm="6">
                  <b-form-group label-for="datepicker-custom2" label="วันที่ยืนราคา">
                    <template v-if="true" v-slot:label><!-- QuoDetail.quo_confirm_price === null || QuoDetail.quo_confirm_price?.toString().trim() === '' -->
                      วันที่ยืนราคา<span style="color: red;"> *</span>
                    </template>
                    <div style="position: relative;">
                      <date-picker id="datepicker-custom2" :config="options2" v-model="QuoDetail.quo_confirm_price" :readonly="mode !== 'add'"/>
                      <i class="ri-calendar-line m-0 icon-calendar-edit" @click="onClickDatePicker(2)"
                        :disabled="isDisable" style="cursor: pointer;" />
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Customer Detail Section -->
              <span style="font-size: 25px; color: rgb(37, 37, 37);">รายละเอียดลูกค้า</span>
              <b-row>
                <b-col lg="4" md="6" sm="12" v-if="mode !== 'edit' && mode !== 'view'">
                  <b-form-group label="ชื่อ-นามสกุล" label-for="cus_name">
                    <div style="position: relative;">
                      <b-form-input
                        id="cus_name"
                        v-model="searchName"
                        placeholder="กรอกชื่อ-นามสกุล"
                        :readonly="mode !== 'add'"
                      ></b-form-input>
                      <a
                        @click="searchCustomerDetailfromName"
                        class="search-link defind-search-icon-cusname"
                        v-if="mode === 'add'"
                      >
                        <i style="font-size: 1.5rem;" class="ri-search-line" />
                      </a>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="6" sm="12">
                  <b-form-group label="เบอร์โทรศัพท์" label-for="cus_tel">
                    <div style="position: relative;">
                      <the-mask
                        mask="###-###-####"
                        class="form-control"
                        v-model="searchTel"
                        id="cus_tel"
                        placeholder="กรอกเบอร์โทรศัพท์"
                        :readonly="mode !== 'add'"
                      ></the-mask>
                      <a
                        @click="searchCustomerDetailfromNumber"
                        class="search-link defind-search-icon-cusname"
                        v-if="mode === 'add'"
                      >
                        <i style="font-size: 1.5rem;" class="ri-search-line" />
                      </a>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="3" md="4" sm="12">
                  <b-form-group class="unselectable" label="ชื่อ-นามสกุล" label-for="cus_name" style="color: #3f414d;">
                    <template v-if="QuoDetail.quo_cus_name === null || QuoDetail.quo_cus_name?.toString().trim() === ''" v-slot:label>
                      ชื่อ-นามสกุล<!-- <span style="color: red;"> *</span> -->
                    </template>
                    <b-form-input id="cus_name" type="text" v-model="QuoDetail.quo_cus_name" :readonly="true"></b-form-input> <!-- placeholder="ชื่อ-นามสกุล" -->
                  </b-form-group>
                </b-col>
                <b-col lg="2" md="2" sm="12">
                  <b-form-group class="unselectable" label="ชื่อเล่น" label-for="cus_nickname" style="color: #3f414d;">
                    <template v-if="QuoDetail.quo_cus_nickname === null || QuoDetail.quo_cus_nickname?.toString().trim() === ''" v-slot:label>
                      ชื่อเล่น<!-- <span style="color: red;"> *</span> -->
                    </template>
                    <b-form-input id="cus_nickname" type="text" v-model="QuoDetail.quo_cus_nickname" :readonly="true"></b-form-input> <!-- placeholder="ชื่อเล่น" -->
                  </b-form-group>
                </b-col>
                <b-col lg="2" md="2" sm="12" v-if="mode === 'add'">
                  <b-form-group class="unselectable" label="เพศ" label-for="cus_gender" style="color: #3f414d;">
                    <template v-if="QuoDetail.quo_cus_gender === null || QuoDetail.quo_cus_gender?.toString().trim() === ''" v-slot:label>
                      เพศ<!-- <span style="color: red;"> *</span> -->
                    </template>
                    <b-form-input id="cus_gender" type="text" v-model="QuoDetail.quo_cus_gender" :readonly="true"></b-form-input><!-- placeholder="เพศ" -->
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="4" sm="12" v-if="mode === 'add'">
                  <b-form-group label-for="datepicker-custom3" label="วันเดือนปีเกิด">
                    <template v-if="QuoDetail.quo_cus_birth_day === null || QuoDetail.quo_cus_birth_day?.toString().trim() === ''" v-slot:label>
                      วันเดือนปีเกิด<!-- <span style="color: red;"> *</span> -->
                    </template>
                    <div style="position: relative;">
                      <date-picker id="datepicker-custom3" :config="options3" v-model="QuoDetail.quo_cus_birth_day" :readonly="true"/>
                      <i class="ri-calendar-line m-0 icon-calendar-edit" @click="onClickDatePicker(3)"
                        :disabled="isDisable" style="cursor: pointer;" />
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="mode === 'add'">
                <b-col lg="3" md="4" sm="12">
                  <b-form-group label="เลขบัตรประชาชน" label-for="cus_citizen_id">
                    <template v-if="QuoDetail.quo_cus_citizen_id === null || QuoDetail.quo_cus_citizen_id?.toString().trim() === ''" v-slot:label>
                      เลขบัตรประชาชน<!-- <span style="color: red;"> *</span> -->
                    </template>
                    <the-mask ref="refCitizen" mask="#-####-#####-##-#" class="form-control" v-model="QuoDetail.quo_cus_citizen_id" id="cus_citizen_id" :readonly="true"></the-mask> <!-- placeholder="กรอกเลขบัตรประชาชน" -->
                  </b-form-group>
                </b-col>
                <b-col lg="3" md="4" sm="12">
                  <b-form-group label="ข้อมูล HN" label-for="cus_hn_no">
                    <template v-if="QuoDetail.quo_hn === null || QuoDetail.quo_hn?.toString().trim() === ''" v-slot:label>
                      ข้อมูล HN<!-- <span style="color: red;"> *</span> -->
                    </template>
                    <b-form-input id="cus_hn_no" v-model="QuoDetail.quo_hn" :readonly="true"></b-form-input> <!-- placeholder="ข้อมูล HN" -->
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Product -->
              <span style="font-size: 25px; color: rgb(37, 37, 37);">ผลิตภัณฑ์</span>
              <br />
              <span style="font-size: 25px; color: rgb(37, 37, 37);">รวม : <span style="color: #00FF29">{{ QuoDetail.quo_total_price }}</span> บาท</span>
              <b-row>
                <b-col cols="12">
                  <div class="fx-gp-quo d-flex my-3" style="white-space: nowrap; gap: .5rem">
                    <b-button v-if="mode !== 'view'" @click="showModalProduct = true" variant="primary" class="max-width-btn-quo-mgt flex-fill text-center btn-min-size" style="text-align: center;"><i class="circle-plus_ct"/>เพิ่มสินค้า</b-button>
                    <b-button v-else class="max-width-btn-quo-mgt flex-fill text-center btn-min-size" style="text-align: center;" disabled><i class="circle-plus_ct"/>เพิ่มสินค้า</b-button>

                    <b-button v-if="mode !== 'view'" @click="showModalService = true" :disabled="isDisable" variant=" bg-success-custom" class="max-width-btn-quo-mgt flex-fill text-center btn-min-size" style="text-align: center;"><i class="circle-plus_ct"/>เพิ่มบริการ</b-button>
                    <b-button v-else class="max-width-btn-quo-mgt flex-fill text-center btn-min-size" style="text-align: center;" disabled><i class="circle-plus_ct"/>เพิ่มบริการ</b-button>

                    <b-form-checkbox  v-model="QuoDetail.quo_is_incl_vat" name="checkbox-1" size="lg" class="checkbox-quo checkbox-quotation-mgt" :disabled="isDisable">ราคารวม Vat(7%)</b-form-checkbox>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="table-responsive">
                    <b-table bordered hover :items="rowSelected.data" :fields="columnsSelected"
                      :current-page="currentPageSelected"
                      :per-page="perPageSelected"
                      :tbody-tr-class="''" thead-class="table-header-color"
                    >
                      <template v-for="(column) in columnsSelected" v-slot:[`cell(${column.key})`]="data">
                        <template v-if="column.key === 'no'">
                          <span :key="column.key">{{ ((currentPageSelected - 1) * perPageSelected) + data.index + 1  }}</span>
                        </template>
                        <template v-if="column.key === 'type_proser'">
                          <span :key="column.key">{{ data.item.type || '-' }}</span>
                        </template>
                        <template v-if="column.key === 'code_proser'">
                          <span :key="column.key">{{ data.item.no || '-' }}</span>
                        </template>
                        <template v-if="column.key === 'name_proser'">
                          <span :key="column.key">{{ data.item.name || data.item.st_name || '-' }}</span>
                        </template>
                        <template v-if="column.key === 'quantity'">
                          <CurrencyInputCom v-model="data.item.quantity" :options="optionCurrency" @change="calculateRow(data.item)" :key="data.item.type + column.key + data.index" :disabled="isDisable"/>
                        </template>
                        <template v-if="column.key === 'lp'">
                          <CurrencyInputCom v-model="data.item.lp" :options="optionCurrency" @change="calculateRow(data.item)" :key="data.item.type + column.key + data.index" :disabled="isDisable"/>
                        </template>
                        <template v-if="column.key === 'discount'">
                          <CurrencyInputCom v-model="data.item.discount" :options="optionCurrency" :isLimit="true" :valueLimit="(data.item.lp || 0) * (data.item.quantity || 0)" @change="calculateRow(data.item)" :key="data.item.type + column.key + data.index" :ref="data.item.id?.replace(/-/g, '')" :disabled="isDisable"/>
                        </template>
                        <template v-if="column.key === 'total_price'">
                          <span :key="column.key">{{ formatNumber(data.item.row_price) }}</span>
                        </template>
                        <template v-if="column.key === 'mgt'">
                          <div style="display: flex; justify-content: center;" :key="column.key">
                            <b-button @click="deleteRow(data.item)" title="ลบ" variant=" iq-bg-bin-custom btn-bin-border" :disabled="isDisable" size="sm"><i class="ri-delete-bin-line m-0"></i></b-button>
                          </div>
                        </template>
                      </template>
                    </b-table>
                  </div>
                </b-col>
              </b-row>
              <b-row style="display: flex; justify-content: center;">
                <b-pagination
                  v-model="currentPageSelected"
                  :total-rows="rowSelected.data?.length"
                  :per-page="perPageSelected"
                  align="center"
                />
              </b-row>
              <b-row>
                <b-col lg="4" md="6" sm="12">
                  <b-form-group label="ข้อคิดเห็น" label-for="remark">
                    <b-textarea id="remark" :disabled="isDisable" v-model="QuoDetail.quo_cus_remark" ></b-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <span style="font-size: 25px; color: rgb(37, 37, 37); text-decoration:underline">วันที่อนุมัติ : {{QuoDetail.quo_approve_date}}</span>

                <div v-if="QuoDetail.so_no" style="margin-top: 20px;">
                  <span style="font-size: 25px; color: rgb(37, 37, 37);">อัปโหลดไฟล์</span>
                  <b-row>
                    <b-col lg="6" md="8" sm="12" class="d-flex custom-flex-abs">
                      <span style="color: black">อัปโหลดไฟล์ที่เกี่ยวข้อง</span>
                      <b-form-file
                        class="custom-file-style"
                        ref="fileInputRef"
                        id="fileInput"
                        accept="image/*, application/pdf"
                        multiple
                        v-model="files.fileSelect"
                        @change="handleFileUpload"
                        :placeholder="files.fileLastest ? files.fileLastest : ''"
                        browse-text="เลือกไฟล์"
                        :disabled="mode === 'view'">
                      </b-form-file>
                    </b-col>
                  </b-row>
                </div>
                              <!-- File List Table -->
              <b-row v-if="rows_upload.length > 0" style="margin-top: 20px;">
                <b-col cols="12">
                  <div class="table-responsive">
                    <b-table
                      bordered
                      hover
                      :items="rows_upload"
                      :fields="columns_upload"
                      :current-page="currentPageUpload"
                      :per-page="perPageUpload"
                      @pagination="onPaginationUpload"
                      :tbody-tr-class="rowClass"
                      thead-class="table-header-color">
                      <template v-slot:cell(no)="data">
                        <span>{{ ((currentPageUpload - 1) * perPageUpload) + data.index + 1 }}</span>
                      </template>
                      <template v-slot:cell(files)="data">
                        <span>{{ data.item.file_name }}</span>
                      </template>
                      <template v-slot:cell(management)="data">
                        <div style="display: flex; justify-content: center;">
                          <b-button
                            variant=" iq-bg-info mr-1"
                            size="sm"
                            @click="downloadfile(data.item)"
                            :disabled="false">
                            <i class="ri-download-fill m-0"></i>
                          </b-button>
                          <b-button
                            v-if="mode !== 'view'"
                            variant=" iq-bg-danger mr-1"
                            size="sm"
                            @click="deletefile(data.index)">
                            <i class="ri-delete-bin-line m-0"></i>
                          </b-button>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="rows_upload.length > 0" style="display: flex; justify-content: center;">
                <b-pagination
                  v-model="currentPageUpload"
                  :total-rows="rows_upload.length"
                  :per-page="perPageUpload"
                  align="center"
                />
              </b-row>

              <!-- GEN SO Modal -->
              <b-modal v-model="genSOModal" title="สร้างคำสั่งซื้อ" :size="'lg'" @close.prevent="genSOModal = false"
                no-close-on-backdrop>
                <div>
                  <b-row v-if="files.quo_qs_id === '91c37841-61cf-4208-8fcf-3002d46e0cd7'">
                    <b-col lg="6" md="8" sm="12" class="d-flex custom-flex-abs">
                      <span style="color: black">อัปโหลดหลักฐานการโอน / ไฟล์ที่เกี่ยวข้อง (ไม่บังคับ)</span>
                      <b-form-file class="custom-file-style" ref="imageInputRef" id="imageInput" accept="image/*, application/pdf"
                        multiple v-model="files.fileSelect" @change="handleImageUpload"
                        :placeholder="files.fileLastest ? files.fileLastest : ''" browse-text="เลือกไฟล์"></b-form-file>
                    </b-col>
                    <b-col lg="3" md="4" sm="12" class="mt-4" style="display: flex; height:45px">
                      <b-button variant="primary-custom" class="btn-min-size" style="border-radius: 0.5rem;" @click="GenerateSO">
                        Generate SO
                      </b-button>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col cols="12" class="table-responsive">
                      <b-table bordered hover :items="rows_upload" :fields="columns_upload" :current-page="currentPageModal"
                        :per-page="perPageModal" @pagination="onPaginationModal" :tbody-tr-class="rowClass"
                        thead-class="table-header-color">
                        <template v-slot:cell(no)="data">
                          <span>{{ data.index + 1 }}</span>
                        </template>
                        <template v-slot:cell(files)="data">
                          <span>{{ data.item.file_name }}</span>
                        </template>
                        <template v-slot:cell(management)="data">
                          <div style="display: flex; justify-content: center;">
                            <b-button variant=" iq-bg-info mr-1" size="sm" @click="downloadfile(data.item)">
                              <i class="ri-download-fill m-0"></i>
                            </b-button>
                            <b-button v-if="files.quo_qs_id === '91c37841-61cf-4208-8fcf-3002d46e0cd7'" variant=" iq-bg-danger mr-1"
                              size="sm" @click="deletefile(data.index)">
                              <i class="ri-delete-bin-line m-0"></i>
                            </b-button>
                          </div>
                        </template>
                      </b-table>
                      <br>
                      <b-pagination v-model="currentPageModal" :total-rows="rows_upload.length" :per-page="perPageModal"
                        align="center" />
                    </b-col>
                  </b-row>
                </div>
                <template #modal-footer>
                  <div class="w-100">
                    <p class="float-left"></p>
                    <b-button variant="none" size="sm" class="float-right iq-bg-danger btn-cancel-border btn-min-size"
                      style="border-radius: 0.5rem;" @click="genSOModal = false">
                      ยกเลิก
                    </b-button>
                  </div>
                </template>
              </b-modal>
              <b-modal v-model="showModalProduct" title="เลือกสินค้า" cancel-title="ยกเลิก" ok-title="เพิ่ม" @ok="onSubmitProductModal" @close="onCloseProductModal" size="xl" :no-close-on-esc="true" :no-close-on-backdrop="true">
                <productSelectModalQuo ref="productSelectedCom" :mainProductSelected="rowSelected.data" :del-list="JSON.parse(JSON.stringify(delList))"/>
                <template #modal-footer>
                  <div class="w-100" style="display: flex; justify-content: flex-end; gap: 0.5rem;">
                    <b-button
                      style="border-radius: 0.5rem; padding: 0 1.1rem !important;"
                      variant="primary"
                      class="btn-min-size"
                      size="sm"
                      @click="onSubmitProductModal"
                    >
                    <i class="save-data_ct"/>บันทึก
                    </b-button>
                    <b-button
                      variant="danger"
                      class="btn-min-size btn-cancel-border"
                      style="border-radius: 0.5rem;"
                      size="sm"
                      @click="showModalProduct=false"
                    >
                      ยกเลิก
                    </b-button>
                  </div>
                </template>
              </b-modal>

              <b-modal v-model="showModalService" title="เลือกบริการ" cancel-title="ยกเลิก" ok-title="เพิ่ม" @ok="onSubmitServiceModal" @close="onCloseServiceModal" size="xl" :no-close-on-esc="true" :no-close-on-backdrop="true">
                <serviceSelectModalQuo ref="serviceSelectedCom" :mainServiceSelected="rowSelected.data" :del-list="JSON.parse(JSON.stringify(delList))"/>
                <template #modal-footer>
                  <div class="w-100" style="display: flex; justify-content: flex-end; gap: 0.5rem;">
                    <b-button
                      style="border-radius: 0.5rem; padding: 0 1.1rem !important;"
                      variant="primary"
                      class="btn-min-size"
                      size="sm"
                      @click="onSubmitServiceModal"
                    >
                    <i class="save-data_ct"/>บันทึก
                    </b-button>
                    <b-button
                      variant="danger"
                      class="btn-min-size btn-cancel-border"
                      style="border-radius: 0.5rem;"
                      size="sm"
                      @click="showModalService=false"
                    >
                      ยกเลิก
                    </b-button>
                  </div>
                </template>
              </b-modal>
            </div>
            <b-row>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped>
.checkbox-quotation-mgt > .custom-control-input:checked~.custom-control-label::before {
  border-color: #0DC268 !important;
  background-color: #0DC268 !important;
}
.defind-search-icon-cusname {
  position: absolute;
  top: 0;
  right: 0;
  padding-right: 0.5rem;
  color: #089bab !important;
}

.defind-search-icon-cusname:hover {
  color: #4e5051 !important;
}
[dir=ltr] .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: #A3A3A3 !important;
  border-color: #A3A3A3 !important;
}

.flex-response-header-quo {
  display: flex;
  gap: .5rem
}

.max-width-btn-quo-mgt {
  max-width: 200px;
}

.checkbox-quo {
  padding: 0;
  margin-left: 1rem;
}
@media (max-width: 376px) {
  .flex-response-header-quo {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0;
  }
  .max-width-btn-quo-mgt {
    max-width: 376px;
    width: 100%;
  }

  .fx-gp-quo {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .checkbox-quo {
    margin-left: 0;
  }
}
</style>

<script>
import { xray } from '../../config/pluginInit'
import router from '@/router'
import Vue from 'vue'
import moment from 'moment'
import { mask } from 'vue-the-mask'
import { configAPI } from '../../configBase'
import productSelectModalQuo from './component/productSelectModalQuo.vue'
import serviceSelectModalQuo from './component/serviceSelectModalQuo.vue'
import CurrencyInputCom from './CurrencyInputCom.vue'
import Axios from 'axios'

const iconDate = {
  time: 'fas fa-clock',
  date: 'fas fa-calendar',
  up: 'fas fa-chevron-up',
  down: 'fas fa-chevron-down',
  previous: 'fas fa-chevron-left',
  next: 'fas fa-chevron-right',
  today: 'fas fa-calendar-day',
  clear: 'fas fa-trash-alt',
  close: 'fas fa-times'
}

export default {
  name: 'QuotationMGT',
  components: {
    productSelectModalQuo,
    serviceSelectModalQuo,
    CurrencyInputCom
  },
  directives: { mask },
  data () {
    return {
      clnId: JSON.parse(sessionStorage.getItem('user')).cln_id || null,
      usrId: JSON.parse(sessionStorage.getItem('user')).usr_id || null,
      mode: 'add',
      showModalProduct: false,
      showModalService: false,
      QuoDetail: {
        quo_no: null,
        quo_date: null,
        quo_confirm_price: null,
        quo_cus_contact_tel: null,
        quo_cus_id: null,
        quo_cus_name: null,
        quo_cus_nickname: null,
        quo_cus_gender: null,
        quo_cus_birth_day: null,
        quo_cus_citizen_id: null,
        quo_hn: null,
        quo_total_price: null,
        quo_approve_date: null,
        quo_is_incl_vat: true,
        quo_cus_remark: null,
        so_no: null,
        so_version: null
      },
      // Store original values for comparison
      originalQuoDetail: {
        quo_is_incl_vat: true,
        quo_cus_remark: null,
        quo_date: null,
        quo_confirm_price: null
      },
      searchTel: null,
      searchName: null,
      rowSelected: {
        data: []
      },
      productSelect: [],
      serviceSelect: [],
      delList: [],
      columnsSelected: [
        { label: 'ลำดับ', key: 'no', class: 'text-center table-size-100-300' },
        { label: 'ประเภท', key: 'type_proser', class: 'text-center table-size-200-400' },
        { label: 'รหัสสินค้า/บริการ', key: 'code_proser', class: 'text-center table-size-200-400 ellips' },
        { label: 'ชื่อสินค้า/บริการ', key: 'name_proser', class: 'text-center table-size-200-400 ellips' },
        { label: 'จำนวน', key: 'quantity', class: 'text-center table-size-200-400' },
        { label: 'ราคา', key: 'lp', class: 'text-center table-size-200-400' },
        { label: 'ส่วนลด', key: 'discount', class: 'text-center table-size-200-400' },
        { label: 'ราคารวม', key: 'total_price', class: 'text-center table-size-200-400' },
        { label: 'จัดการ', key: 'mgt', class: 'text-center my-column' }
      ],
      currentPageSelected: 1,
      perPageSelected: 10,
      isDisable: false,
      options: {
        // https://momentjs.com/docs/#/displaying/
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: false,
        showClose: true,
        useStrict: true,
        minDate: false,
        // stepping: 1,
        icons: iconDate,
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'auto'
        }
      },
      options2: {
        // https://momentjs.com/docs/#/displaying/
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: false,
        showClose: true,
        useStrict: true,
        minDate: false,
        // stepping: 1,
        icons: iconDate,
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'auto'
        }
      },
      options3: {
        // https://momentjs.com/docs/#/displaying/
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: false,
        showClose: true,
        useStrict: true,
        minDate: false,
        maxDate: moment(new Date()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate(),
        // stepping: 1,
        icons: iconDate,
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'auto'
        }
      },
      optionCurrency: {
        currency: 'EUR',
        currencyDisplay: 'hidden',
        valueRange: {
          min: 0,
          max: 1e+53
        },
        precision: 0,
        hideCurrencySymbolOnFocus: true,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: false,
        useGrouping: true,
        accountingSign: false
      },
      refCitizen: null,
      // File upload related data
      files: {
        fileCollection: [],
        fileSelect: [],
        fileLastest: null,
        quo_id: null,
        quo_qs_id: null
      },
      rows_upload: [],
      deletedFiles: [], // เก็บรายการไฟล์ที่ผู้ใช้ลบแล้ว (pending delete)
      columns_upload: [
        { label: 'ลำดับ', key: 'no', class: 'text-center' },
        { label: 'เอกสาร', key: 'files', class: 'text-center table-size-200-400 ellips' },
        { label: 'จัดการ', key: 'management', class: 'text-center' }
      ],
      currentPageUpload: 1,
      perPageUpload: 10,
      // SO Generation Modal properties
      genSOModal: false,
      currentPageModal: 1,
      perPageModal: 10
    }
  },
  async mounted () {
    // await this.getcustomerforDD()
    if (this.$route.params.setPage === 'edit') {
      this.mode = 'edit'
      this.isDisable = false
      await this.getQuotationById()
    } else if (this.$route.params.setPage === 'view') {
      this.mode = 'view'
      this.isDisable = true
      await this.getQuotationById()
    } else {
      this.mode = 'add'
      this.isDisable = false
      this.options.minDate = moment(new Date()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
      this.options2.minDate = moment(new Date()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
      this.QuoDetail.quo_date = moment(new Date())
      setTimeout(() => {
        this.QuoDetail.quo_confirm_price = moment(new Date()).add('minute', 1)
      }, [200])

      // Initialize original values for new quotation
      this.originalQuoDetail = {
        quo_is_incl_vat: this.QuoDetail.quo_is_incl_vat,
        quo_cus_remark: this.QuoDetail.quo_cus_remark,
        quo_date: this.QuoDetail.quo_date,
        quo_confirm_price: this.QuoDetail.quo_confirm_price
      }

      // Handle customer data from URL parameters (from ServiceUsage pages or Patient)
      const query = this.$route.query
      if (query.customerId && query.customerName) {
        // Pre-fill customer information
        this.QuoDetail.quo_cus_id = query.customerId
        this.QuoDetail.quo_cus_name = decodeURIComponent(query.customerName)
        this.searchName = decodeURIComponent(query.customerName)

        // Store the customer ID for later use (if needed for other purposes)
        // this.customerIdFromServiceUsage = query.customerId

        // For example, if you have more customer details in the URL
        if (query.customerTel) {
          this.QuoDetail.quo_cus_contact_tel = query.customerTel
          this.searchTel = query.customerTel
        }
        if (query.customerHn) {
          this.QuoDetail.quo_hn = query.customerHn
        }
        if (query.customerCitizenId) {
          this.QuoDetail.quo_cus_citizen_id = this.formatCitizenId(query.customerCitizenId)
        }
        if (query.customerNickname) {
          this.QuoDetail.quo_cus_nickname = query.customerNickname
        }
        if (query.customerGender) {
          this.QuoDetail.quo_cus_gender = query.customerGender
        }
        if (query.customerBirthday) {
          this.QuoDetail.quo_cus_birth_day = query.customerBirthday
        }
      }

      // If in edit mode and coming from ServiceUsage pages, create sessionStorage data
      if (this.mode === 'edit' && (query.from === 'ServiceUsage' || query.from === 'ServiceUsageHistory')) {
        const currentPageData = {
          from: query.from,
          mode: 'edit',
          id: this.$route.params.id,
          searchData: {
            id: query.customerId,
            fullname: query.customerName ? decodeURIComponent(query.customerName) : '',
            tel: query.customerTel || '',
            hn_no: query.customerHn || '',
            id_card: query.customerCitizenId || '',
            nickname: query.customerNickname || '',
            gender: query.customerGender || '',
            birthday: query.customerBirthday || ''
          },
          dataForSave: {},
          customerData: {
            id: query.customerId,
            fullname: query.customerName ? decodeURIComponent(query.customerName) : '',
            tel: query.customerTel || '',
            hn_no: query.customerHn || '',
            id_card: query.customerCitizenId || '',
            nickname: query.customerNickname || '',
            gender: query.customerGender || '',
            birthday: query.customerBirthday || ''
          }
        }
        sessionStorage.setItem('serviceUsageReturnData', JSON.stringify(currentPageData))
      }
    }
    xray.index()
  },
  watch: {
    'QuoDetail.quo_total_price': {
      handler: function (val, oldVal) {
        this.QuoDetail.quo_total_price = this.formatNumber(val)
      },
      deep: true
    },
    'rowSelected.data': {
      handler: function (val, oldVal) {
        this.calculateTotal()
      },
      deep: true
    },
    'QuoDetail.quo_date': {
      handler: function (val, oldVal) {
        if (val !== null && oldVal !== null) {
          this.QuoDetail.quo_confirm_price = null
          this.options2.minDate = new Date(moment(val, 'DD/MM/YYYY'))
        } else if (val !== '' && oldVal === '') {
          this.options2.minDate = new Date(moment(val, 'DD/MM/YYYY'))
        }
      },
      deep: true
    },
    'QuoDetail.quo_is_incl_vat': {
      handler: function (val, oldVal) {
        this.calculateTotal()
      },
      deep: true
    }
  },
  methods: {
    formatCitizenId (id) {
      if (!id) return ''
      const digits = id.replace(/-/g, '')
      if (digits.length !== 13) return id
      return digits.replace(/^(\d)(\d{4})(\d{5})(\d{2})(\d)$/, '$1-$2-$3-$4-$5')
    },
    rowClass (item, type) {
      if (!item || type !== 'row') return
      const index = this.rowSelected.data.findIndex(el => el.id === item.id)
      if (index % 2 === 1) return 'table-body-color'
    },
    formatNumber (value) {
      if (value === null || value === undefined) {
        return ''
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getFullImagePath (relativePath) {
      if (relativePath !== null && relativePath !== '') {
        let path = relativePath !== null ? relativePath.slice(1) : ''
        const baseURL = configAPI.MA_PORT + path
        return baseURL
      } else {
        return 'https://www.w3schools.com/howto/img_avatar.png'
      }
    },
    SwalError (error, message) {
      Vue.swal.fire({
        title: `<span class="" style="font-size: 25px; color: black; text-align: center">${message}</span>`,
        html: '<span>' + error + '</span>',
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
        confirmButtonColor: '#089bab',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1'
        }
      })
    },
    onClickDatePicker (number) {
      const datepicker = document.getElementById(`datepicker-custom${number}`)
      datepicker.focus()
    },
    handleClickBack () {
      Vue.swal.fire({
        title: '<span class="" style="font-size: 25px; color: black; text-align: center">คุณมั่นใจว่าคุณจะออกจากหน้านี้ใช่หรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // ตรวจสอบว่ามาจากหน้าไหน
          const referrer = document.referrer

          // Check if coming from ServiceUsage pages
          if (this.$route.query.from === 'ServiceUsage' || this.$route.query.from === 'ServiceUsageHistory') {
            // Store tab information for returning to ServiceUsage pages
            const returnData = sessionStorage.getItem('serviceUsageReturnData')
            if (returnData) {
              const parsedData = JSON.parse(returnData)
              // Set activeTab to tab2 (หัตถการ / บริการ) for returning
              parsedData.activeTab = 'tab2'
              sessionStorage.setItem('serviceUsageReturnData', JSON.stringify(parsedData))
            } else {
            }
            // Return to the previous ServiceUsage page
            router.go(-1)
          } else if (this.$route.query.from === 'Patient' || this.$route.query.from === 'ServiceUsagePatient' || this.$route.query.from === 'patient') {
            // ถ้ามาจากหน้า Patient หรือ ServiceUsage/Patient ให้กลับไปหน้า Patient
            router.push('/Patient')
          } else if (this.$route.fullPath.includes('soAdmin')) {
            router.push('/SaleOrderApproveEdit')
          } else if (this.$route.fullPath.includes('so')) {
            router.push('/SaleOrderTable')
          } else if (referrer.includes('/Patient') || this.$route.query.from === 'patient') {
            // ถ้ามาจากหน้า Patient ให้กลับไปหน้า Patient
            router.push('/Patient')
          } else {
            router.push('/QuotationTable')
          }
        }
      })
    },
    async searchCustomerDetailfromName () {
      if (!this.searchName || this.searchName.toString().trim() === '') {
        Vue.swal.fire({
          title: `<span style="font-size: 25px; color: black; text-align: center">กรุณากรอกชื่อ-นามสกุลให้ครบถ้วน</span>`,
          icon: 'warning',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
          confirmButtonColor: '#089bab',
          customClass: {
            confirmButton: 'custom-confirm-button-class mx-1'
          }
        })
      } else {
        await Axios.request({
          method: 'get',
          url: `${configAPI.MA_PORT}/api/clinic/${this.clnId}/getcustomerfromName/${this.searchName}`,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          if (res.data.data.length > 0) {
            this.QuoDetail.quo_cus_id = res.data.data[0].cus_id || null
            this.QuoDetail.quo_cus_name = (res.data.data[0].cus_firstname + ' ' + res.data.data[0].cus_lastname) || null
            this.QuoDetail.quo_cus_nickname = res.data.data[0].cus_nickname || null
            this.QuoDetail.quo_cus_gender = res.data.data[0].cus_gender || null
            this.QuoDetail.quo_cus_birth_day = res.data.data[0].cus_birth_day !== null ? moment(res.data.data[0].cus_birth_day).format('DD/MM/YYYY') : null
            this.QuoDetail.quo_cus_citizen_id = this.formatCitizenId(res.data.data[0].cus_citizen_id) || null
            this.QuoDetail.quo_hn = res.data.data[0].cus_hn || null
            this.QuoDetail.quo_cus_contact_tel = res.data.data[0].cus_tel || null
          } else {
            this.QuoDetail.quo_cus_id = null
            this.QuoDetail.quo_cus_name = null
            this.QuoDetail.quo_cus_nickname = null
            this.QuoDetail.quo_cus_gender = null
            this.QuoDetail.quo_cus_birth_day = null
            this.QuoDetail.quo_cus_citizen_id = null
            this.QuoDetail.quo_hn = null
            this.QuoDetail.quo_cus_contact_tel = null
          }
        }).catch((err) => {
          this.SwalError(err, 'Error')
        })
      }
    },
    async searchCustomerDetailfromNumber () {
      if (this.searchTel === null || this.searchTel?.length < 10) {
        Vue.swal.fire({
          title: `<span class="" style="font-size: 25px; color: black; text-align: center">กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน</span>`,
          icon: 'warning',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
          confirmButtonColor: '#089bab',
          customClass: {
            confirmButton: 'custom-confirm-button-class mx-1'
          }
        })
      } else {
        await Axios.request({
          method: 'get',
          url: `${configAPI.MA_PORT}/api/clinic/${this.clnId}/getcustomerfromNumber/${this.searchTel}`,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          if (res.data.data.length > 0) {
            this.QuoDetail.quo_cus_id = res.data.data[0].cus_id || null
            this.QuoDetail.quo_cus_name = (res.data.data[0].cus_firstname + ' ' + res.data.data[0].cus_lastname) || null
            this.QuoDetail.quo_cus_nickname = res.data.data[0].cus_nickname || null
            this.QuoDetail.quo_cus_gender = res.data.data[0].cus_gender || null
            this.QuoDetail.quo_cus_birth_day = res.data.data[0].cus_birth_day !== null ? moment(res.data.data[0].cus_birth_day).format('DD/MM/YYYY') : null
            this.QuoDetail.quo_cus_citizen_id = this.formatCitizenId(res.data.data[0].cus_citizen_id) || null
            this.QuoDetail.quo_hn = res.data.data[0].cus_hn || null
            this.QuoDetail.quo_cus_contact_tel = res.data.data[0].cus_tel || null
          } else {
            this.QuoDetail.quo_cus_id = null
            this.QuoDetail.quo_cus_name = null
            this.QuoDetail.quo_cus_nickname = null
            this.QuoDetail.quo_cus_gender = null
            this.QuoDetail.quo_cus_birth_day = null
            this.QuoDetail.quo_cus_citizen_id = null
            this.QuoDetail.quo_hn = null
            this.QuoDetail.quo_cus_contact_tel = null
          }
        }).catch((err) => {
          this.SwalError(err, 'Error')
        })
      }
    },
    calculateTotal () {
      let total = 0
      let totalProduct = 0
      let totalService = 0
      let product = []
      let service = []
      for (let item of this.rowSelected.data) {
        if (parseFloat((((item.lp || 0) * (item.quantity || 0)) - parseFloat(item.discount?.toString().replace(/,/g, '') || 0)).toFixed(2)) < 0) {
          this.$refs[item.id?.replace(/-/g, '')][0].formattedValue = 0
          item.discount = 0
        }
        if (item.type === 'Product') {
          item.row_price = parseFloat(((item.lp || 0) * (item.quantity || 0) - (parseFloat(item.discount?.toString().replace(/,/g, '')) || 0)).toFixed(2))
          totalProduct += parseFloat(item.row_price || 0)
          product.push(item)
        } else {
          item.row_price = parseFloat(((item.lp || 0) * (item.quantity || 0) - (parseFloat(item.discount?.toString().replace(/,/g, '')) || 0)).toFixed(2))
          totalService += parseFloat(item.row_price || 0)
          service.push(item)
        }
      }
      if (this.QuoDetail.quo_is_incl_vat) {
        totalProduct = parseFloat(totalProduct || 0) * 1.07
      }
      total = parseFloat((totalProduct + totalService))
      this.productSelect = product
      this.serviceSelect = service
      total = parseFloat(total.toFixed(2))
      this.QuoDetail.quo_total_price = total
    },
    calculateRow (item) {
      if (item.qp_id) {
        item.status = 'update'
      } else {
        item.status = 'add'
      }
      const _index = this.rowSelected.data.findIndex(el => el.id === item.id)
      if (_index >= 0) {
        this.rowSelected.data[_index] = item
      }
      this.calculateTotal()
    },
    onSubmitProductModal () {
      let Old = JSON.parse(JSON.stringify(this.productSelect))
      let [New, Del] = this.$refs.productSelectedCom.submitAction()
      this.productSelect = []
      this.rowSelected.data = []
      for (let item of New) {
        const _indexDel = Del.findIndex(el => el?.id === item?.id)
        if (_indexDel !== -1) {
          item = Del[_indexDel]
          Del.splice(_indexDel, 1)
        }
        let index = Old.findIndex(el => el.id === item.id)
        if (index < 0) {
          this.productSelect.push(item)
        } else {
          this.productSelect.push(Old[index])
        }
      }
      this.delList = Del
      this.rowSelected.data = [...this.productSelect, ...this.serviceSelect]
      this.showModalProduct = false
    },
    onCloseProductModal () {
      this.showModalProduct = false
    },
    onSubmitServiceModal () {
      let [New, Del] = this.$refs.serviceSelectedCom.submitAction()
      let Old = this.serviceSelect
      this.serviceSelect = []
      this.rowSelected.data = []
      for (let item of New) {
        const _indexDel = Del.findIndex(el => el?.id === item?.id)
        if (_indexDel !== -1) {
          item = Del[_indexDel]
          Del.splice(_indexDel, 1)
        }
        let index = Old.findIndex(el => el.id === item.id)
        if (index < 0) {
          this.serviceSelect.push(item)
        } else {
          this.serviceSelect.push(Old[index])
        }
      }
      this.delList = Del
      this.rowSelected.data = [...this.productSelect, ...this.serviceSelect]
      this.showModalService = false
    },
    onCloseServiceModal () {
      this.showModalService = false
    },
    deleteRow (item) {
      let temp = this.rowSelected.data
      let tempProduct = this.productSelect
      let tempService = this.serviceSelect
      let index = temp.findIndex(el => el.id === item.id)
      let indexProduct = tempProduct.findIndex(el => el.id === item.id)
      let indexService = tempService.findIndex(el => el.id === item.id)
      if (indexProduct >= 0) {
        tempProduct.splice(indexProduct, 1)
      }
      if (indexService >= 0) {
        tempService.splice(indexService, 1)
      }
      if (index >= 0) {
        if (temp[index].qp_id && this.delList.find(el => el.qp_id === temp[index].qp_id) === undefined) {
          this.delList.push(temp[index])
        }
        temp.splice(index, 1)
      }
      this.rowSelected.data = temp
      this.calculateTotal()
    },
    async checkSave () {
      let errList = []
      if (this.QuoDetail.quo_date === null || this.QuoDetail.quo_date?.toString().trim() === '') {
        errList.push('กรุณาเลือก วันที่เสนอราคา')
      }
      if (this.QuoDetail.quo_confirm_price === null || this.QuoDetail.quo_confirm_price?.toString().trim() === '') {
        errList.push('กรุณาเลือก วันที่ยืนราคา')
      }
      if (this.QuoDetail.quo_cus_name === null || this.QuoDetail.quo_cus_name?.toString().trim() === '') {
        errList.push('กรุณา ค้นหาลูกค้า')
      }
      if (this.rowSelected.data.length <= 0) {
        errList.push('กรุณาเลือกสินค้า/บริการ อย่างน้อย 1 รายการ')
      } else {
        // filter สินค้าที่ไม่มีจำนวน หรือ ราคา
        let temp = this.rowSelected.data.filter((item) => {
          return item.quantity === null || item.quantity === '' || item.quantity === 0 || item.quantity === '0' || item.lp === null || item.lp === '' || item.lp === 0 || item.lp === '0'
        })
        if (temp.length > 0) {
          errList.push('</hr>')
          errList.push(`สินค้า/บริการที่ข้อมูลไม่ครบถ้วน`)
          for (let item of temp) {
            errList.push(`${item.type} : <span class="ellipsModal">${item.name || item.st_name}</span>`)
          }
        }
      }
      return errList
    },

    // ตรวจสอบว่ามีการเปลี่ยนแปลงข้อมูลหรือไม่
    hasDataChanges () {
      // ตรวจสอบว่ามีไฟล์ใหม่ที่เลือกหรือไม่
      const hasNewFiles = this.files.fileCollection && this.files.fileCollection.length > 0

      // ตรวจสอบว่ามีการลบไฟล์หรือไม่
      const hasDeletedFiles = this.delList && this.delList.length > 0

      // ตรวจสอบว่ามีไฟล์ที่ถูกทำเครื่องหมายให้ลบหรือไม่
      const hasMarkedDeletedFiles = this.deletedFiles && this.deletedFiles.length > 0

      // ตรวจสอบว่ามีการเปลี่ยนแปลงข้อมูลอื่นๆ หรือไม่
      const hasOtherChanges = this.rowSelected.data.some(item => item.status === 'add' || item.status === 'update')

      // ตรวจสอบการเปลี่ยนแปลง VAT และ remarks
      const hasVatOrRemarksChanges = this.QuoDetail.quo_is_incl_vat !== this.originalQuoDetail.quo_is_incl_vat ||
                                    this.QuoDetail.quo_cus_remark !== this.originalQuoDetail.quo_cus_remark

      return hasNewFiles || hasDeletedFiles || hasMarkedDeletedFiles || hasOtherChanges || hasVatOrRemarksChanges
    },

    // ตรวจสอบว่ามีการเปลี่ยนแปลงเฉพาะ VAT หรือ remarks หรือไม่
    hasOnlyVatOrRemarksChanges () {
      // ตรวจสอบว่ามีไฟล์ใหม่ที่เลือกหรือไม่
      const hasNewFiles = this.files.fileCollection && this.files.fileCollection.length > 0

      // ตรวจสอบว่ามีการลบไฟล์หรือไม่
      const hasDeletedFiles = this.delList && this.delList.length > 0

      // ตรวจสอบว่ามีไฟล์ที่ถูกทำเครื่องหมายให้ลบหรือไม่
      const hasMarkedDeletedFiles = this.deletedFiles && this.deletedFiles.length > 0

      // ตรวจสอบว่ามีการเปลี่ยนแปลงข้อมูลอื่นๆ หรือไม่
      const hasOtherChanges = this.rowSelected.data.some(item => item.status === 'add' || item.status === 'update')

      // ตรวจสอบการเปลี่ยนแปลง VAT และ remarks
      const hasVatOrRemarksChanges = this.QuoDetail.quo_is_incl_vat !== this.originalQuoDetail.quo_is_incl_vat ||
                                    this.QuoDetail.quo_cus_remark !== this.originalQuoDetail.quo_cus_remark

      // ถ้ามีการเปลี่ยนแปลงเฉพาะ VAT หรือ remarks และไม่มีข้อมูลอื่นที่เปลี่ยนแปลง
      return hasVatOrRemarksChanges && !hasNewFiles && !hasDeletedFiles && !hasMarkedDeletedFiles && !hasOtherChanges
    },

    // Method สำหรับแก้ไขเฉพาะ VAT และ remarks
    async editVatAndRemarks () {
      try {
        let dataForEdit = {
          quo_is_incl_vat: this.QuoDetail.quo_is_incl_vat,
          quo_cus_remark: this.QuoDetail.quo_cus_remark,
          quo_date: this.originalQuoDetail.quo_date ? new Date(moment(this.originalQuoDetail.quo_date, 'DD/MM/YYYY')) : null,
          quo_confirm_price: this.originalQuoDetail.quo_confirm_price ? new Date(moment(this.originalQuoDetail.quo_confirm_price, 'DD/MM/YYYY')) : null,
          quo_total_price: this.QuoDetail.quo_total_price?.toString().replace(/,/g, '') || null,
          usrId: this.usrId,
          clnId: this.clnId
        }

        await Axios.request({
          method: 'POST',
          url: `${configAPI.SALE_PORT}/api/clinic/${this.clnId}/editQuotation/${this.$route.params.id}`,
          headers: {
            'Content-Type': 'application/json'
          },
          data: dataForEdit
        })

        // Update original values after successful edit
        this.originalQuoDetail.quo_is_incl_vat = this.QuoDetail.quo_is_incl_vat
        this.originalQuoDetail.quo_cus_remark = this.QuoDetail.quo_cus_remark

        Vue.swal.fire({
          title: `<span class="" style="font-size: 25px; color: black; text-align: center">แก้ไขสำเร็จ</span>`,
          icon: 'success',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.navigateBack()
        })
      } catch (err) {
        this.SwalError(err, 'Error')
      }
    },

    // Method สำหรับนำทางกลับไปยังหน้าต้นทาง
    navigateBack () {
      // ตรวจสอบว่ามาจากหน้าไหน
      const referrer = document.referrer

      // Check if coming from ServiceUsage pages
      if (this.$route.query.from === 'ServiceUsage' || this.$route.query.from === 'ServiceUsageHistory') {
        // Store tab information for returning to ServiceUsage pages
        const returnData = sessionStorage.getItem('serviceUsageReturnData')
        if (returnData) {
          const parsedData = JSON.parse(returnData)
          // Set activeTab to tab2 (หัตถการ / บริการ) for returning
          parsedData.activeTab = 'tab2'
          sessionStorage.setItem('serviceUsageReturnData', JSON.stringify(parsedData))
        }
        // Return to the previous ServiceUsage page
        router.go(-1)
      } else if (this.$route.query.from === 'Patient' || this.$route.query.from === 'ServiceUsagePatient' || this.$route.query.from === 'patient') {
        // ถ้ามาจากหน้า Patient หรือ ServiceUsage/Patient ให้กลับไปหน้า Patient
        router.push('/Patient')
      } else if (this.$route.fullPath.includes('soAdmin')) {
        router.push('/SaleOrderApproveEdit')
      } else if (this.$route.fullPath.includes('so')) {
        router.push('/SaleOrderTable')
      } else if (referrer.includes('/Patient')) {
        // ถ้ามาจากหน้า Patient ให้กลับไปหน้า Patient
        router.push('/Patient')
      } else {
        router.push('/QuotationTable')
      }
    },
    saveQuotation () {
      Vue.swal.fire({
        title: `<span class="" style="font-size: 25px; color: black; text-align: center">คุณมั่นใจว่าจะบันทึกใช่หรือไม่</span>`,
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          let errorList = await this.checkSave()
          if (errorList.length > 0) {
            let message = ''
            errorList.forEach((item) => {
              message += `${item} <br>`
            })
            this.SwalError(message, 'กรุณากรอกข้อมลให้ครบถ้วน')
          } else {
            // Ask if user wants to generate SO first
            Vue.swal.fire({
              title: `<span class="" style="font-size: 25px; color: black; text-align: center">คุณต้องการสร้างคำสั่งซื้อเลยหรือไม่</span>`,
              icon: 'question',
              showCancelButton: true,
              confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
              confirmButtonColor: '#089bab',
              cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
              cancelButtonColor: '#d33',
              customClass: {
                confirmButton: 'custom-confirm-button-class mx-1',
                cancelButton: 'custom-confirm-button-class mx-1'
              }
            }).then(async (result) => {
              if (result.isConfirmed) {
                // ตรวจสอบราคารวมกับราคาขั้นต่ำก่อนแสดง modal สร้างคำสั่งซื้อ
                const priceValidation = await this.checkPriceValidation()

                if (priceValidation.hasError) {
                  let errorMessage = 'ไม่สามารถสร้างคำสั่งซื้อได้เนื่องจากราคารวมน้อยกว่าราคาขั้นต่ำ:<br><br>'
                  priceValidation.messages.forEach(msg => {
                    errorMessage += `• ${msg}<br>`
                  })

                  Vue.swal.fire({
                    title: `<span class="" style="font-size: 25px; color: black; text-align: center">ไม่สามารถสร้างคำสั่งซื้อได้</span>`,
                    html: errorMessage,
                    icon: 'warning',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: true,
                    width: '800px',
                    confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
                    confirmButtonColor: '#089bab',
                    customClass: {
                      confirmButton: 'custom-confirm-button-class mx-1'
                    }
                  })
                  return
                }

                // Show SO generation modal without saving quotation first
                this.files.quo_id = null // Will be set after saving
                this.files.quo_qs_id = '91c37841-61cf-4208-8fcf-3002d46e0cd7' // Default QS ID for SO generation
                this.files.fileCollection = []
                this.files.fileLastest = null
                this.files.fileSelect = []
                this.genSOModal = true
              } else {
                // User chose not to generate SO, just save quotation
                try {
                  let dataforsave = {
                    quo_no: this.QuoDetail.quo_no || null,
                    quo_date: this.QuoDetail.quo_date ? new Date(moment(this.QuoDetail.quo_date, 'DD/MM/YYYY')) : null,
                    quo_confirm_price: this.QuoDetail.quo_confirm_price ? new Date(moment(this.QuoDetail.quo_confirm_price, 'DD/MM/YYYY')) : null,
                    quo_cus_id: this.QuoDetail.quo_cus_id || null,
                    so_cus_id: this.QuoDetail.quo_cus_id || null,
                    quo_cus_name: this.QuoDetail.quo_cus_name || null,
                    quo_cus_contact_tel: this.QuoDetail.quo_cus_contact_tel || null,
                    quo_cus_nickname: this.QuoDetail.quo_cus_nickname || null,
                    quo_cus_gender: this.QuoDetail.quo_cus_gender || null,
                    quo_cus_birth_day: this.QuoDetail.quo_cus_birth_day ? new Date(moment(this.QuoDetail.quo_cus_birth_day, 'DD/MM/YYYY')) : null,
                    quo_hn: this.QuoDetail.quo_hn || null,
                    quo_cus_citizen_id: this.QuoDetail.quo_cus_citizen_id || null,
                    quo_cus_remark: this.QuoDetail.quo_cus_remark || null,
                    // quo_discount: this.QuoDetail.quo_discount || null,
                    quo_total_price: this.QuoDetail.quo_total_price || null,
                    quo_is_incl_vat: this.QuoDetail.quo_is_incl_vat,
                    usrId: this.usrId,
                    clnId: this.clnId,
                    quo_pro_ser: this.rowSelected.data
                  }
                  const res = await Axios.request({
                    method: 'POST',
                    url: `${configAPI.SALE_PORT}/api/clinic/${this.clnId}/saveQuotation`,
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    data: dataforsave
                  })

                  // Get quo_id from response
                  let savedQuoId = null
                  if (res.data?.data && res.data.data.length > 0 && res.data.data[0]?.quo_id) {
                    savedQuoId = res.data.data[0].quo_id
                  }

                  // Upload files if any new files are selected OR if there are existing files
                  if ((this.files.fileCollection && this.files.fileCollection.length > 0) || (this.rows_upload && this.rows_upload.length > 0)) {
                    let fileData = new FormData()

                    // Convert existing files to File objects and add them
                    const existingFileObjects = await this.convertExistingFilesToFileObjects()
                    for (let i = 0; i < existingFileObjects.length; i++) {
                      fileData.append('file', existingFileObjects[i])
                    }

                    // Add new files
                    if (this.files.fileCollection && this.files.fileCollection.length > 0) {
                      for (let i = 0; i < this.files.fileCollection.length; i++) {
                        fileData.append('file', this.files.fileCollection[i])
                      }
                    }

                    fileData.append('user_id', this.usrId)

                    // Use savedQuoId from saveQuotation response
                    if (savedQuoId) {
                      await Axios.request({
                        method: 'post',
                        url: `${configAPI.SALE_PORT}/upload/uploadmany/id/${savedQuoId}/key/quotation`,
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        },
                        data: fileData
                      })
                    }
                  }

                  Vue.swal.fire({
                    title: `<span class="" style="font-size: 25px; color: black; text-align: center">บันทึกสำเร็จ</span>`,
                    icon: 'success',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    timer: 1500
                  }).then(() => {
                    this.navigateBack()
                  })
                } catch (err) {
                  this.SwalError(err, 'Error')
                }
              }
            })
          }
        }
      })
    },
    async getQuotationById () {
      await Axios.request({
        method: 'GET',
        url: `${configAPI.SALE_PORT}/api/clinic/${this.clnId}/quotation/${this.$route.params.id}`,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        let tempData = res.data.data[0]
        this.QuoDetail = {
          quo_no: tempData?.quo_no || null,
          quo_date: tempData?.quo_date ? moment(tempData?.quo_date).format('DD/MM/YYYY') : '',
          quo_confirm_price: tempData?.quo_confirm_price ? moment(tempData?.quo_confirm_price).format('DD/MM/YYYY') : '',
          quo_cus_id: tempData?.quo_cus_id || null,
          quo_cus_contact_tel: tempData?.quo_cus_contact_tel || null,
          quo_cus_name: tempData?.quo_cus_name || null,
          quo_cus_nickname: tempData?.quo_cus_nickname || null,
          quo_cus_gender: tempData?.quo_cus_gender || null,
          quo_cus_birth_day: tempData?.quo_cus_birth_day ? moment(tempData?.quo_cus_birth_day).format('DD/MM/YYYY') : '',
          quo_cus_citizen_id: tempData?.quo_cus_citizen_id || null,
          quo_hn: tempData?.quo_hn || null,
          quo_cus_remark: tempData?.quo_cus_remark || null,
          // quo_discount: tempData?.quo_discount || null,
          quo_total_price: tempData?.quo_total_price || null,
          quo_approve_date: tempData?.quo_approve_date ? moment(tempData?.quo_approve_date).format('DD/MM/YYYY') : '',
          quo_is_incl_vat: tempData?.quo_is_incl_vat,
          so_no: tempData?.so_no || null,
          so_version: tempData?.so_version || null
        }

        // Store original values for comparison
        this.originalQuoDetail = {
          quo_is_incl_vat: tempData?.quo_is_incl_vat || true,
          quo_cus_remark: tempData?.quo_cus_remark || null,
          quo_date: tempData?.quo_date ? moment(tempData?.quo_date).format('DD/MM/YYYY') : null,
          quo_confirm_price: tempData?.quo_confirm_price ? moment(tempData?.quo_confirm_price).format('DD/MM/YYYY') : null
        }
        this.searchTel = tempData?.quo_cus_contact_tel || null
        this.options.minDate = new Date(moment(this.QuoDetail.quo_date, 'DD/MM/YYYY'))
        if (tempData.pro_ser?.length > 0) {
          for (let item of tempData?.pro_ser) {
            if (item.qp_prd_id) {
              item.id = item.qp_prd_id
              item.type = 'Product'
              item.is_select = true
              item.quantity = item.qp_amount
              item.lp = item.qp_price
              item.discount = item.qp_discount
              item.row_price = item.qp_total_price
              this.productSelect.push(item)
            } else if (item.qp_ser_id) {
              item.id = item.qp_ser_id
              item.type = 'Service'
              item.is_select = true
              item.quantity = item.qp_amount
              item.lp = item.qp_price
              item.discount = item.qp_discount
              item.row_price = item.qp_total_price
              this.serviceSelect.push(item)
            }
          }
        }
        this.rowSelected.data = tempData?.pro_ser

        // Load files if so_no exists
        if (this.QuoDetail.so_no) {
          this.getFileByRefId()
        }

        // Reset deleted files when loading existing quotation
        this.deletedFiles = []

        // Update original values after loading quotation
        this.$nextTick(() => {
          this.originalQuoDetail = {
            quo_is_incl_vat: this.QuoDetail.quo_is_incl_vat,
            quo_cus_remark: this.QuoDetail.quo_cus_remark,
            quo_date: this.QuoDetail.quo_date,
            quo_confirm_price: this.QuoDetail.quo_confirm_price
          }
        })
      }).catch((err) => {
        this.SwalError(err, 'Error')
      })
    },
    async editQuotation () {
      Vue.swal.fire({
        title: `<span class="" style="font-size: 25px; color: black; text-align: center">คุณมั่นใจว่าจะแก้ไขใช่หรือไม่</span>`,
        icon: 'warning',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          // ตรวจสอบว่ามีการเปลี่ยนแปลงข้อมูลหรือไม่
          const hasChanges = this.hasDataChanges()

          // ถ้าไม่มีไฟล์ใหม่และไม่มีข้อมูลอื่นที่เปลี่ยนแปลง ให้ข้ามการตรวจสอบข้อมูล
          if (!hasChanges) {
            // ถ้าไม่มีไฟล์ใหม่ ให้แสดงข้อความและกลับไปหน้าต้นทาง
            Vue.swal.fire({
              title: `<span class="" style="font-size: 25px; color: black; text-align: center">ไม่มีข้อมูลที่เปลี่ยนแปลง</span>`,
              icon: 'info',
              allowEscapeKey: false,
              allowOutsideClick: false,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.navigateBack()
            })
            return
          }

          // ตรวจสอบว่ามีการเปลี่ยนแปลงเฉพาะ VAT หรือ remarks หรือไม่
          if (this.hasOnlyVatOrRemarksChanges()) {
            await this.editVatAndRemarks()
            return
          }

          let errorList = await this.checkSave()
          if (errorList.length > 0) {
            let message = ''
            errorList.forEach((item) => {
              message += `${item} <br>`
            })
            this.SwalError(message, 'กรุณากรอกข้อมลให้ครบถ้วน')
          } else {
            // ตรวจสอบว่ามีการเปลี่ยนแปลงข้อมูลอื่นๆ นอกเหนือจากไฟล์หรือไม่
            const hasOtherChanges = this.rowSelected.data.some(item => item.status === 'add' || item.status === 'update') || this.delList.length > 0

            if (hasOtherChanges) {
              // ลบไฟล์ที่ถูกทำเครื่องหมายไว้ก่อน
              await this.deleteMarkedFiles()

              // ถ้ามีการเปลี่ยนแปลงข้อมูลอื่นๆ ให้เรียก API saveQuotation
              let dataforEdit = {
                quo_id: this.QuoDetail.so_no ? this.$route.params.id : null, // Include quo_id when saving SO
                quo_no: this.QuoDetail.quo_no || null,
                quo_date: this.QuoDetail.quo_date ? new Date(moment(this.QuoDetail.quo_date, 'DD/MM/YYYY')) : null,
                quo_confirm_price: this.QuoDetail.quo_confirm_price ? new Date(moment(this.QuoDetail.quo_confirm_price, 'DD/MM/YYYY')) : null,
                quo_cus_id: this.QuoDetail.quo_cus_id || null,
                quo_cus_name: this.QuoDetail.quo_cus_name || null,
                quo_cus_contact_tel: this.QuoDetail.quo_cus_contact_tel || null,
                quo_cus_nickname: this.QuoDetail.quo_cus_nickname || null,
                quo_cus_gender: this.QuoDetail.quo_cus_gender || null,
                quo_cus_birth_day: this.QuoDetail.quo_cus_birth_day ? new Date(moment(this.QuoDetail.quo_cus_birth_day, 'DD/MM/YYYY')) : null,
                quo_cus_citizen_id: this.QuoDetail.quo_cus_citizen_id || null,
                quo_hn: this.QuoDetail.quo_hn || null,
                quo_cus_remark: this.QuoDetail.quo_cus_remark || null,
                // quo_discount: this.QuoDetail.quo_discount,
                quo_total_price: this.QuoDetail.quo_total_price?.toString().replace(/,/g, '') || null,
                usrId: this.usrId,
                clnId: this.clnId,
                quo_pro_ser: this.rowSelected.data,
                delList: this.delList
              }

              try {
                // Use saveQuotation endpoint when so_no exists (creates new version)
                let endpoint = this.QuoDetail.so_no
                  ? `${configAPI.SALE_PORT}/api/clinic/${this.clnId}/saveQuotation`
                  : `${configAPI.SALE_PORT}/api/clinic/${this.clnId}/editQuotation/${this.$route.params.id}`

                let response = await Axios.request({
                  method: 'POST',
                  url: endpoint,
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  data: dataforEdit
                })

                // Get the new quotation ID for file upload
                let newQuoId = null
                if (this.QuoDetail.so_no && response.data?.data && response.data.data.length > 0 && response.data.data[0]?.quo_id) {
                  newQuoId = response.data.data[0].quo_id
                } else {
                  newQuoId = this.$route.params.id
                }

                // Upload files if any new files are selected OR if there are existing files
                if ((this.files.fileCollection && this.files.fileCollection.length > 0) || (this.rows_upload && this.rows_upload.length > 0)) {
                  let fileData = new FormData()

                  // Convert existing files to File objects and add them
                  // (ไฟล์ที่ถูกลบไปแล้วจะไม่ถูกส่งไปเพราะถูกลบจาก rows_upload แล้ว)
                  const existingFileObjects = await this.convertExistingFilesToFileObjects()
                  for (let i = 0; i < existingFileObjects.length; i++) {
                    fileData.append('file', existingFileObjects[i])
                  }

                  // Add new files
                  if (this.files.fileCollection && this.files.fileCollection.length > 0) {
                    for (let i = 0; i < this.files.fileCollection.length; i++) {
                      fileData.append('file', this.files.fileCollection[i])
                    }
                  }

                  fileData.append('user_id', this.usrId)

                  if (newQuoId) {
                    await Axios.request({
                      method: 'post',
                      url: `${configAPI.SALE_PORT}/upload/uploadmany/id/${newQuoId}/key/quotation`,
                      headers: {
                        'Content-Type': 'multipart/form-data'
                      },
                      data: fileData
                    })
                  }
                }

                Vue.swal.fire({
                  title: `<span class="" style="font-size: 25px; color: black; text-align: center">${this.QuoDetail.so_no ? 'บันทึก SO สำเร็จ' : 'แก้ไขสำเร็จ'}</span>`,
                  icon: 'success',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  this.navigateBack()
                })
              } catch (err) {
                this.SwalError(err, 'Error')
              }
            } else {
              // ถ้ามีแค่การเปลี่ยนแปลงไฟล์ (ลบหรือเพิ่ม) ให้ลบไฟล์ที่ทำเครื่องหมายไว้ก่อน
              await this.deleteMarkedFiles()

              try {
                // อัปโหลดไฟล์ใหม่ (ถ้ามี)
                if (this.files.fileCollection && this.files.fileCollection.length > 0) {
                  let fileData = new FormData()

                  // Add only new files (ส่งเฉพาะไฟล์ใหม่)
                  for (let i = 0; i < this.files.fileCollection.length; i++) {
                    fileData.append('file', this.files.fileCollection[i])
                  }

                  fileData.append('user_id', this.usrId)

                  await Axios.request({
                    method: 'post',
                    url: `${configAPI.SALE_PORT}/upload/uploadmany/id/${this.$route.params.id}/key/quotation`,
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                    data: fileData
                  })
                }

                Vue.swal.fire({
                  title: `<span class="" style="font-size: 25px; color: black; text-align: center">บันทึกไฟล์สำเร็จ</span>`,
                  icon: 'success',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  this.navigateBack()
                })
              } catch (err) {
                this.SwalError(err, 'Error')
              }
            }
          }
        }
      })
    },

    // File upload methods
    handleFileUpload (event) {
      this.files.fileSelect = []
      let inputfiles = event.target.files
      let filesCurrent = this.files.fileCollection

      // แยกไฟล์เก่าที่มาจาก getFileByRefId (มี ul_path_file หรือ file_path) กับไฟล์ใหม่ที่ผู้ใช้เลือก
      let existingFilesFromServer = this.rows_upload.filter(item =>
        (item.ul_path_file || item.file_path) && !item.file // ไฟล์จากเซิร์ฟเวอร์ไม่มี file object
      )
      let newlySelectedFiles = this.rows_upload.filter(item =>
        item.file // ไฟล์ที่ผู้ใช้เลือกจะมี file object
      )

      let tempfiles = [] // for push to this.files.fileCollection
      let tempRows = [] // for push to this.rows_upload
      let datatemp = {
        file_name: null,
        file_type: null,
        file: null
      }

      // รีเซ็ตเฉพาะไฟล์ใหม่ แต่เก็บไฟล์เก่าจากเซิร์ฟเวอร์ไว้
      this.files.fileCollection = []

      for (let index = 0; index < inputfiles.length; index++) {
        // ตรวจสอบชื่อไฟล์ซ้ำกับไฟล์ที่มีอยู่แล้วทั้งหมด
        let allExistingFiles = existingFilesFromServer.concat(newlySelectedFiles)
        let checkSameName = allExistingFiles.findIndex((item) => {
          return (item.file_name || item.ul_file_name) === inputfiles[index].name
        })

        if (checkSameName === -1) {
          datatemp.file_name = inputfiles[index].name
          datatemp.file_type = inputfiles[index].type
          datatemp.file = inputfiles[index]
          tempfiles.push(inputfiles[index])
          tempRows.push(datatemp)
          datatemp = {
            file_name: null,
            file_type: null,
            file: null
          }
        }
      }

      this.files.fileCollection = filesCurrent.concat(tempfiles)
      // รวมไฟล์เก่าจากเซิร์ฟเวอร์ + ไฟล์ใหม่ที่เลือก
      this.rows_upload = existingFilesFromServer.concat(tempRows)
    },

    async uploadFiles () {
      if (this.files.fileCollection.length === 0) {
        Vue.swal.fire({
          title: '<span class="" style="font-size: 25px; color: black; text-align: center">กรุณาเลือกไฟล์ที่ต้องการอัพโหลด</span>',
          icon: 'warning',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
          confirmButtonColor: '#089bab',
          customClass: {
            confirmButton: 'custom-confirm-button-class mx-1'
          }
        })
        return
      }

      Vue.swal.fire({
        title: '<span class="" style="font-size: 25px; color: black; text-align: center">คุณต้องการอัปโหลดไฟล์ใช่หรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            let data = new FormData()

            // Add only new files (ส่งเฉพาะไฟล์ใหม่ที่ผู้ใช้เลือก)
            for (let i = 0; i < this.files.fileCollection.length; i++) {
              data.append('file', this.files.fileCollection[i])
            }

            data.append('user_id', this.usrId)

            await Axios.request({
              method: 'post',
              url: `${configAPI.SALE_PORT}/upload/uploadmany/id/${this.$route.params.id}/key/quotation`,
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              data: data
            }).then((response) => {
              Vue.swal.fire({
                title: '<span class="" style="font-size: 25px; color: black; text-align: center">อัปโหลดไฟล์สำเร็จ</span>',
                icon: 'success',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                // Clear file selection and refresh file list
                this.files.fileSelect = []
                this.files.fileCollection = []
                this.files.fileLastest = null
                this.getFileByRefId()
              })
            })
          } catch (error) {
            Vue.swal.fire({
              title: '<span class="" style="font-size: 25px; color: black; text-align: center">เกิดข้อผิดพลาด</span>',
              html: '<span>' + error.message + '</span>',
              icon: 'warning',
              allowEscapeKey: false,
              allowOutsideClick: false,
              showConfirmButton: true,
              confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
              confirmButtonColor: '#089bab',
              customClass: {
                confirmButton: 'custom-confirm-button-class mx-1'
              }
            })
          }
        }
      })
    },

    async downloadfile (fileitem) {
      try {
        // รองรับทั้ง field name แบบเก่าและใหม่
        const filePath = fileitem.file_path || fileitem.ul_path_file
        const fileName = fileitem.file_name || fileitem.ul_file_name

        await Axios.request({
          method: 'get',
          url: this.getFullImagePath(filePath),
          responseType: 'blob'
        }).then(response => {
          let fileUrl = window.URL.createObjectURL(new Blob([response.data]))
          let fileLink = document.createElement('a')
          fileLink.href = fileUrl
          fileLink.setAttribute('download', fileName)
          document.body.appendChild(fileLink)
          fileLink.click()
          document.body.removeChild(fileLink)
        })
      } catch (error) {
        this.SwalError('ไม่สามารถดาวน์โหลดไฟล์ได้', 'เกิดข้อผิดพลาดในการดาวน์โหลด')
      }
    },

    deletefile (idx) {
      const fileToDelete = this.rows_upload[idx]

      Vue.swal.fire({
        title: '<span class="" style="font-size: 25px; color: black; text-align: center">คุณต้องการลบไฟล์นี้ใช่หรือไม่?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
        confirmButtonColor: '#089bab',
        cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'custom-confirm-button-class mx-1',
          cancelButton: 'custom-confirm-button-class mx-1'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // ถ้าเป็นไฟล์เก่าที่มีอยู่ในระบบ (มี ul_id) ให้เก็บไว้ใน deletedFiles สำหรับลบจริงตอนบันทึก SO
          if (fileToDelete && (fileToDelete.ul_id || fileToDelete.id)) {
            this.deletedFiles.push(fileToDelete)
          }

          // ถ้าเป็นไฟล์ใหม่ที่ผู้ใช้เลือก (มี file object) ให้ลบจาก fileCollection
          if (fileToDelete && fileToDelete.file) {
            const fileIndex = this.files.fileCollection.findIndex(file =>
              file.name === fileToDelete.file_name &&
              file.size === fileToDelete.file.size
            )
            if (fileIndex !== -1) {
              this.files.fileCollection.splice(fileIndex, 1)
            }
          }

          // ลบจาก UI
          this.rows_upload.splice(idx, 1)
          this.files.fileSelect = []
          this.files.fileLastest = null
        }
      })
    },

    onPaginationUpload (page) {
      this.currentPageUpload = page
    },

    // Method สำหรับลบไฟล์จริงจาก server (เรียกตอนบันทึก SO)
    async deleteMarkedFiles () {
      const deletePromises = []

      for (const fileToDelete of this.deletedFiles) {
        if (fileToDelete && (fileToDelete.ul_id || fileToDelete.id)) {
          const fileId = fileToDelete.ul_id || fileToDelete.id
          const deletePromise = Axios.request({
            method: 'delete',
            url: `${configAPI.SALE_PORT}/upload/deleteFile/${fileId}`,
            headers: {
              'Content-Type': 'application/json'
            }
          })
          deletePromises.push(deletePromise)
        }
      }

      // รอให้ลบไฟล์ทั้งหมดเสร็จ
      await Promise.all(deletePromises)

      // ล้าง deletedFiles หลังจากลบเสร็จแล้ว
      this.deletedFiles = []
    },

    async getFileByRefId () {
      try {
        await Axios.request({
          method: 'get',
          url: `${configAPI.SALE_PORT}/upload/getFileByRefId/${this.$route.params.id}`,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then((response) => {
          this.rows_upload = response.data.data || []
        })
      } catch (error) {
        this.rows_upload = []
      }
    },

    // Method to convert existing files to File objects
    async convertExistingFilesToFileObjects () {
      const existingFiles = []

      if (this.rows_upload && this.rows_upload.length > 0) {
        for (const fileItem of this.rows_upload) {
          try {
            // ใช้ field name ที่ถูกต้องตาม downloadfile method
            const filePath = fileItem.file_path || fileItem.ul_path_file
            const fileName = fileItem.file_name || fileItem.ul_file_name
            const fileType = fileItem.file_type || fileItem.ul_type_file

            // ข้ามไฟล์ที่ไม่มี path หรือ name หรือเป็นไฟล์ใหม่ที่ผู้ใช้เลือก
            if (!filePath || !fileName || fileItem.file) {
              continue
            }

            // ดาวน์โหลดไฟล์จากเซิร์ฟเวอร์
            const response = await Axios.request({
              method: 'get',
              url: this.getFullImagePath(filePath),
              responseType: 'blob'
            })

            // ตัดชื่อไฟล์เอาเฉพาะส่วนหลัง _ อันแรก
            let newFileName = fileName
            if (fileName.includes('_')) {
              const parts = fileName.split('_')
              if (parts.length > 1) {
                newFileName = parts.slice(1).join('_') // เอาเฉพาะส่วนหลัง _ อันแรก
              }
            }

            // แปลง blob เป็น File object
            const file = new File([response.data], newFileName, {
              type: fileType || 'application/octet-stream'
            })

            existingFiles.push(file)
          } catch (error) {
            // ถ้าดาวน์โหลดไม่ได้ ให้ข้ามไฟล์นั้น
          }
        }
      }

      return existingFiles
    },

    // SO Generation Modal methods
    handleImageUpload (event) {
      this.files.fileSelect = []
      let inputfiles = event.target.files
      let filesCurrent = this.files.fileCollection
      let rowsCurrent = JSON.parse(JSON.stringify(this.rows_upload))
      let tempfiles = [] // for push to this.files.fileCollection
      let tempRows = [] // for push to this.rows_upload
      let datatemp = {
        file_name: null,
        file_type: null,
        file: null
      }
      this.files.fileCollection = []
      this.rows_upload = []
      for (let index = 0; index < inputfiles.length; index++) {
        // check same name in currentfiles if same not push
        let checkSameName = rowsCurrent.findIndex((item) => {
          return item.file_name === inputfiles[index].name
        })
        if (checkSameName === -1) {
          datatemp.file_name = inputfiles[index].name
          datatemp.file_type = inputfiles[index].type
          datatemp.file = inputfiles[index]
          tempfiles.push(inputfiles[index])
          tempRows.push(datatemp)
          datatemp = {
            file_name: null,
            file_type: null,
            file: null
          }
        }
      }
      this.files.fileCollection = filesCurrent.concat(tempfiles)
      this.rows_upload = rowsCurrent.concat(tempRows)
    },

    async checkfiles () {
      let error = []
      // ไม่บังคับเลือกไฟล์แล้ว
      return error
    },

    onPaginationModal (page) {
      this.currentPageModal = page
    },

    async GenerateSO () {
      let error = await this.checkfiles()
      if (error.length > 0) {
        Vue.swal.fire({
          title: '<span class="" style="font-size: 25px; color: black; text-align: center">เกิดข้อผิดพลาด</span>',
          html: '<span>' + error + '</span>',
          icon: 'warning',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
          confirmButtonColor: '#089bab',
          customClass: {
            confirmButton: 'custom-confirm-button-class mx-1'
          }
        })
      } else {
        // check confirm swal
        Vue.swal.fire({
          title: '<span class="" style="font-size: 25px; color: black; text-align: center">คุณต้องการสร้างคำสั่งซื้อใช่หรือไม่?</span>',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ใช่</b-button>',
          confirmButtonColor: '#089bab',
          cancelButtonText: '<b-button style="font-size: 14px; text-align: center">ไม่</b-button>',
          cancelButtonColor: '#d33',
          customClass: {
            confirmButton: 'custom-confirm-button-class mx-1',
            cancelButton: 'custom-confirm-button-class mx-1'
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            // Save quotation first if not already saved
            if (!this.files.quo_id) {
              try {
                let dataforsave = {
                  quo_no: this.QuoDetail.quo_no || null,
                  quo_date: this.QuoDetail.quo_date ? new Date(moment(this.QuoDetail.quo_date, 'DD/MM/YYYY')) : null,
                  quo_confirm_price: this.QuoDetail.quo_confirm_price ? new Date(moment(this.QuoDetail.quo_confirm_price, 'DD/MM/YYYY')) : null,
                  quo_cus_id: this.QuoDetail.quo_cus_id || null,
                  so_cus_id: this.QuoDetail.quo_cus_id || null,
                  quo_cus_name: this.QuoDetail.quo_cus_name || null,
                  quo_cus_contact_tel: this.QuoDetail.quo_cus_contact_tel || null,
                  quo_cus_nickname: this.QuoDetail.quo_cus_nickname || null,
                  quo_cus_gender: this.QuoDetail.quo_cus_gender || null,
                  quo_cus_birth_day: this.QuoDetail.quo_cus_birth_day ? new Date(moment(this.QuoDetail.quo_cus_birth_day, 'DD/MM/YYYY')) : null,
                  quo_hn: this.QuoDetail.quo_hn || null,
                  quo_cus_citizen_id: this.QuoDetail.quo_cus_citizen_id || null,
                  quo_cus_remark: this.QuoDetail.quo_cus_remark || null,
                  // quo_discount: this.QuoDetail.quo_discount || null,
                  quo_total_price: this.QuoDetail.quo_total_price || null,
                  quo_is_incl_vat: this.QuoDetail.quo_is_incl_vat,
                  usrId: this.usrId,
                  clnId: this.clnId,
                  quo_pro_ser: this.rowSelected.data
                }
                const res = await Axios.request({
                  method: 'POST',
                  url: `${configAPI.SALE_PORT}/api/clinic/${this.clnId}/saveQuotation`,
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  data: dataforsave
                })

                // Get quo_id from response
                if (res.data?.data && res.data.data.length > 0 && res.data.data[0]?.quo_id) {
                  this.files.quo_id = res.data.data[0].quo_id
                }

                // Upload files if any new files are selected OR if there are existing files
                if ((this.files.fileCollection && this.files.fileCollection.length > 0) || (this.rows_upload && this.rows_upload.length > 0)) {
                  let fileData = new FormData()

                  // Convert existing files to File objects and add them
                  const existingFileObjects = await this.convertExistingFilesToFileObjects()
                  for (let i = 0; i < existingFileObjects.length; i++) {
                    fileData.append('file', existingFileObjects[i])
                  }

                  // Add new files
                  if (this.files.fileCollection && this.files.fileCollection.length > 0) {
                    for (let i = 0; i < this.files.fileCollection.length; i++) {
                      fileData.append('file', this.files.fileCollection[i])
                    }
                  }

                  fileData.append('user_id', this.usrId)

                  // Use savedQuoId from saveQuotation response
                  if (this.files.quo_id) {
                    await Axios.request({
                      method: 'post',
                      url: `${configAPI.SALE_PORT}/upload/uploadmany/id/${this.files.quo_id}/key/quotation`,
                      headers: {
                        'Content-Type': 'multipart/form-data'
                      },
                      data: fileData
                    })
                  }
                }
              } catch (err) {
                this.SwalError(err, 'Error')
                return
              }
            }

            // Now generate SO
            let generateSaleOrderAPI = {
              method: 'post',
              url: `${configAPI.SALE_PORT}/api/clinic/${this.clnId}/quotation/${this.files.quo_id}/generateSaleOrder`,
              headers: {
                'Content-Type': 'application/json'
              },
              data: {
                user_id: this.usrId
              }
            }

            await Axios.request(generateSaleOrderAPI)
              .then(async (response) => {
                if (response.status) {
                  Vue.swal.fire({
                    title: '<span class="" style="font-size: 25px; color: black; text-align: center">สร้างคำสั่งซื้อสำเร็จ</span>',
                    icon: 'success',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    timer: 1500
                  }).then(() => {
                    this.genSOModal = false
                    this.navigateBack()
                  })
                }
              })
              .catch((error) => {
                Vue.swal.fire({
                  title: '<span class="" style="font-size: 25px; color: black; text-align: center">เกิดข้อผิดพลาด</span>',
                  html: '<span>' + error + '</span>',
                  icon: 'warning',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  showConfirmButton: true,
                  confirmButtonText: '<b-button style="font-size: 14px; text-align: center">ตกลง</b-button>',
                  confirmButtonColor: '#089bab',
                  customClass: {
                    confirmButton: 'custom-confirm-button-class mx-1'
                  }
                })
              })
          }
        })
      }
    },
    // Method สำหรับตรวจสอบราคารวมกับราคาขั้นต่ำของสินค้า/บริการ
    async checkPriceValidation () {
      try {
        let hasPriceError = false
        let errorMessages = []

        for (let item of this.rowSelected.data) {
          if (item.type === 'Product') {
            // ตรวจสอบราคาสินค้า
            try {
              const response = await Axios.request({
                method: 'GET',
                url: `${configAPI.MA_PORT}/api/clinic/${this.clnId}/productforselect?search=${item.no || ''}`,
                headers: {
                  'Content-Type': 'application/json'
                }
              })

              if (response.data.data && response.data.data.length > 0) {
                const productData = response.data.data.find(p => p.id === item.id)

                if (productData && productData.minimum_price !== null && productData.minimum_price !== undefined) {
                  let itemTotalPrice = parseFloat(item.row_price || 0)

                  // ถ้าเลือกราคารวม VAT ให้คำนวณ VAT เพิ่ม
                  if (this.QuoDetail.quo_is_incl_vat) {
                    itemTotalPrice = itemTotalPrice * 1.07
                  }

                  const minimumPrice = parseFloat(productData.minimum_price || 0)

                  if (itemTotalPrice < minimumPrice) {
                    hasPriceError = true
                    const errorMsg = `สินค้า: ${item.name || item.st_name} - ราคารวม (${itemTotalPrice.toFixed(2)}) น้อยกว่าราคาขั้นต่ำ (${minimumPrice})`
                    errorMessages.push(errorMsg)
                  }
                } else {
                  // ใช้ราคาขั้นต่ำจากแหล่งข้อมูลอื่น หรือตั้งค่าเริ่มต้น
                  let minimumPrice = 0
                  let priceSource = ''
                  if (productData?.minimum_price && productData.minimum_price > 0) {
                    // ใช้ minimum_price เป็นราคาขั้นต่ำ
                    minimumPrice = parseFloat(productData.minimum_price || 0)
                    priceSource = 'minimum_price (ราคาขั้นต่ำ)'
                  } else if (productData?.price && productData.price > 0) {
                    // ใช้ราคาขายเป็นราคาขั้นต่ำ
                    minimumPrice = parseFloat(productData.price || 0)
                    priceSource = 'price (ราคาขาย)'
                  } else if (productData?.normal_price && productData.normal_price > 0) {
                    // ใช้ราคาปกติเป็นราคาขั้นต่ำ
                    minimumPrice = parseFloat(productData.normal_price || 0)
                    priceSource = 'normal_price (ราคาปกติ)'
                  } else {
                    // ตั้งค่าราคาขั้นต่ำเริ่มต้น (เช่น 50 บาท)
                    minimumPrice = 50
                    priceSource = 'ค่าเริ่มต้น (50 บาท)'
                  }

                  let itemTotalPrice = parseFloat(item.row_price || 0)

                  // ถ้าเลือกราคารวม VAT ให้คำนวณ VAT เพิ่ม
                  if (this.QuoDetail.quo_is_incl_vat) {
                    itemTotalPrice = itemTotalPrice * 1.07
                  }

                  if (itemTotalPrice < minimumPrice) {
                    hasPriceError = true
                    const errorMsg = `สินค้า: ${item.name || item.st_name} - ราคารวม (${itemTotalPrice.toFixed(2)}) น้อยกว่าราคาขั้นต่ำ (${minimumPrice}) [จาก: ${priceSource}]`
                    errorMessages.push(errorMsg)
                  }
                }
              } else {
              }
            } catch (apiError) {
            }
          } else if (item.type === 'Service') {
            // ตรวจสอบราคาบริการ
            try {
              const response = await Axios.request({
                method: 'GET',
                url: `${configAPI.MA_PORT}/api/clinic/${this.clnId}/serviceforselect?search=${item.no || ''}`,
                headers: {
                  'Content-Type': 'application/json'
                }
              })

              if (response.data.data && response.data.data.length > 0) {
                const serviceData = response.data.data.find(s => s.id === item.id)
                if (serviceData && serviceData.minimum_price !== null && serviceData.minimum_price !== undefined) {
                  let itemTotalPrice = parseFloat(item.row_price || 0)

                  // ถ้าเลือกราคารวม VAT ให้คำนวณ VAT เพิ่ม
                  if (this.QuoDetail.quo_is_incl_vat) {
                    itemTotalPrice = itemTotalPrice * 1.07
                  }

                  const minimumPrice = parseFloat(serviceData.minimum_price || 0)

                  if (itemTotalPrice < minimumPrice) {
                    hasPriceError = true
                    const errorMsg = `บริการ: ${item.name || item.st_name} - ราคารวม (${itemTotalPrice.toFixed(2)}) น้อยกว่าราคาขั้นต่ำ (${minimumPrice})`
                    errorMessages.push(errorMsg)
                  }
                } else {
                  // ใช้ราคาขั้นต่ำจากแหล่งข้อมูลอื่น หรือตั้งค่าเริ่มต้น
                  let minimumPrice = 0
                  let priceSource = ''
                  if (serviceData?.minimum_price && serviceData.minimum_price > 0) {
                    // ใช้ minimum_price เป็นราคาขั้นต่ำ
                    minimumPrice = parseFloat(serviceData.minimum_price || 0)
                    priceSource = 'minimum_price (ราคาขั้นต่ำ)'
                  } else if (serviceData?.price && serviceData.price > 0) {
                    // ใช้ราคาขายเป็นราคาขั้นต่ำ
                    minimumPrice = parseFloat(serviceData.price || 0)
                    priceSource = 'price (ราคาขาย)'
                  } else if (serviceData?.normal_price && serviceData.normal_price > 0) {
                    // ใช้ราคาปกติเป็นราคาขั้นต่ำ
                    minimumPrice = parseFloat(serviceData.normal_price || 0)
                    priceSource = 'normal_price (ราคาปกติ)'
                    // ตั้งค่าราคาขั้นต่ำเริ่มต้น (เช่น 100 บาท)
                    minimumPrice = 100
                    priceSource = 'ค่าเริ่มต้น (100 บาท)'
                  }

                  let itemTotalPrice = parseFloat(item.row_price || 0)

                  // ถ้าเลือกราคารวม VAT ให้คำนวณ VAT เพิ่ม
                  if (this.QuoDetail.quo_is_incl_vat) {
                    itemTotalPrice = itemTotalPrice * 1.07
                  }
                  if (itemTotalPrice < minimumPrice) {
                    hasPriceError = true
                    const errorMsg = `บริการ: ${item.name || item.st_name} - ราคารวม (${itemTotalPrice.toFixed(2)}) น้อยกว่าราคาขั้นต่ำ (${minimumPrice}) [จาก: ${priceSource}]`
                    errorMessages.push(errorMsg)
                  }
                }
              }
            } catch (apiError) {
            }
          }
        }
        return {
          hasError: hasPriceError,
          messages: errorMessages
        }
      } catch (error) {
        return {
          hasError: false,
          messages: []
        }
      }
    }
  }
}
</script>
